import { computed } from "mobx";
import { useCallback, useMemo } from "react";
import { useAuthStore } from "..";
import { DealStatus } from "../interfaces/IDeal";

const useGetDealColor = (): (status: DealStatus, stageName: string) => string => {
    const authStore = useAuthStore();
    const colorSchema = useMemo(() => computed(() => authStore.user!.companyColorSchemeSettings), []).get();

    return useCallback((status: DealStatus, stageName: string): string => {
        if (status === DealStatus.Open)
            return colorSchema.stagesDisplaySettings.find(sds => sds.stageName === stageName)?.displayColor || "#000000";

        if (status === DealStatus.Won)
            return colorSchema.dealsStatusDisplaySettings.find(st => st.dealStatusName === "Won")!.displayColor;

        return colorSchema.dealsStatusDisplaySettings.find(st => st.dealStatusName === "Lost")!.displayColor;
    }, [colorSchema]);
};

export default useGetDealColor;